import React from "react";
import { Link } from "react-router-dom";
const Home = () => {
  return (
    <div style={{ height: "100vh", padding: "20px", backgroundColor: "#232323", color: "white" }}>
      <h1 style={{ fontSize: "48px", marginBottom: "20px" }}>Homepage</h1>
      <p style={{ fontSize: "18px", marginBottom: "30px" }}>
        This project was generated By{" "}
        <a href="https://www.dhiwise.com" style={{ color: "#87CEFA", textDecoration: "none" }}>
          Dhiwise
        </a>
        . Quickly use below links to navigate through all pages.
      </p>
      <ul style={{ listStyle: "none", padding: "0" }}>

      <li style={{ marginBottom: "10px" }}>
          <Link to="/car-full-profile" style={{ color: "#87CEFA", textDecoration: "none" }}>
          CarFullProfile
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/cars" style={{ color: "#87CEFA", textDecoration: "none" }}>
          CarCatalogDealer          </Link>
        </li>

        <li style={{ marginBottom: "10px" }}>
          <Link to="/all-cars-lines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllCarsLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/codeprovider" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CodeProvider
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/signnprovider" style={{ color: "#87CEFA", textDecoration: "none" }}>
            SignnProvider
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/sendnewoffer" style={{ color: "#87CEFA", textDecoration: "none" }}>
            SendNewOffer
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/codedealer" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CodeDealer
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/signindealer" style={{ color: "#87CEFA", textDecoration: "none" }}>
            SignInDealer
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/dashboredprovider" style={{ color: "#87CEFA", textDecoration: "none" }}>
            DashboredProvider
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alladdsprovidercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllAddsProviderCubes
          </Link>
        </li>
      
        <li style={{ marginBottom: "10px" }}>
          <Link to="/mazaltovyougetnewoffer" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MazalTovYouGetNewOffer
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/mazaltovofferapproved" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MazalTovOfferApproved
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/mazaltovofferapprovedline" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MazalTovOfferApprovedLine
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/profilprovider" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ProfilProvider
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/myproviders" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MyProviders
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/dashboreddealerempty" style={{ color: "#87CEFA", textDecoration: "none" }}>
            DashboredDealerEmpty
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alladdsprovidercubes1" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllAddsProviderCubes1
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/mazaltovoffersent" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MazalTovOfferSent
          </Link>
        </li>
    
        <li style={{ marginBottom: "10px" }}>
          <Link to="/offerpagedealer" style={{ color: "#87CEFA", textDecoration: "none" }}>
            OfferPageDealer
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alladdsdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllAddsDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alladdsdealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllAddsDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/dashboreddealer" style={{ color: "#87CEFA", textDecoration: "none" }}>
            DashboredDealer
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/awaitingaddsproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AwaitingAddsProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/awaitingaddsprovidercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AwaitingAddsProviderCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/woncarpurchase" style={{ color: "#87CEFA", textDecoration: "none" }}>
            WonCarPurchase
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/newaddsdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            NewAddsDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/newaddsdealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            NewAddsDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carswithquotesprovidercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarsWithQuotesProviderCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carswithquotesproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarsWithQuotesProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/midprocessoffersproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MidProcessOffersProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/archiveconfirm" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ArchiveConfirm
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carprofil1" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarProfil
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carprofil2" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarProfil2
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alloffersproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllOffersProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/newoffersproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            NewOffersProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/archiveoffersproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ArchiveOffersProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alloffersproviderlines1" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllOffersProviderLines1
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/testfile2after" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Testfile2after
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/awaitingadsdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AwaitingAdsDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/awaitingadsdealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AwaitingAdsDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/tenderadsproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            TenderAdsProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/tenderadsprovidercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            TenderAdsProviderCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alloffersdealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllOffersDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/alloffersdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AllOffersDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addpageprovider" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddPageProvider
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/awaitingadsdealerlines1" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AwaitingAdsDealerLines1
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/approvedadsdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ApprovedAdsDealerCubes
          </Link>
        </li>
   
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carpackageadsproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarPackageAdsProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carpackageadsprovidercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarPackageAdsProviderCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/awaitingapprovaldealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AwaitingApprovalDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/awaitingapprovaldealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AwaitingApprovalDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/approvedadsdealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ApprovedAdsDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/tenderadsdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            TenderAdsDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/approvedadsprovidercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ApprovedAdsProviderCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/adswithbidsproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AdsWithBidsProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/approvedoffersdealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ApprovedOffersDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/approvedoffersdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ApprovedOffersDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/mazaltovnewpackage" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MazalTovNewPackage
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carpackagedealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarPackageDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/carpackagedealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CarPackageDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/rejectedoffersdealerlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            RejectedOffersDealerLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/archiveadsproviderlines" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ArchiveAdsProviderLines
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/rejectedoffersdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            RejectedOffersDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/archiveadsprovidercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ArchiveAdsProviderCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addcarspackage" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddCarsPackage
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/archiveaddsdealercubes" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ArchiveAddsDealerCubes
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/notifications2" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Notifications2
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/settings" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Settings
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/notifications" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Notifications
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addcarinfo2" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddCarInfo2
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addcarinfo" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddCarInfo
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addcarimages" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddCarImages
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addcarimages2" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddCarImages2
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addcarvideo" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddCarVideo
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/addadditinalcardetails" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AddAdditinalCarDetails
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/adsummary" style={{ color: "#87CEFA", textDecoration: "none" }}>
            AdSummary
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/mazaltovadd" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MazalTovAdd
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/mazaltov2" style={{ color: "#87CEFA", textDecoration: "none" }}>
            MazalTov2
          </Link>
        </li>
      </ul>
    </div>
  );
};
export default Home;
